import { StateCreator } from 'zustand';

type LocalGeneral = {
  deploymentVersion: string | undefined;
  isCookiesAccepted: boolean;
  isAgeVerified: boolean;
  ageVerifiedTimestamp: number | null;
};

export type GeneralSlice = {
  general: LocalGeneral;
  setDeploymentVersion: (version: string | undefined) => void;
  acceptCookies: () => void;
  acceptAgeVerification: () => void;
  resetAgeVerification: () => void;
  checkAgeVerification: () => void;
};

const defaultValue: LocalGeneral = {
  deploymentVersion: undefined,
  isCookiesAccepted: true,
  isAgeVerified: false,
  ageVerifiedTimestamp: null,
};

const AGE_VERIFICATION_EXPIRY_TIME = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const createGeneralSlice: StateCreator<GeneralSlice> = set => ({
  general: defaultValue,
  acceptCookies: () =>
    set(state => ({
      general: {
        ...state.general,
        isCookiesAccepted: true,
      },
    })),
  setDeploymentVersion: version =>
    set(state => ({
      general: {
        ...state.general,
        deploymentVersion: version,
      },
    })),
  acceptAgeVerification: () => {
    const timestamp = Date.now();
    set(state => ({
      general: {
        ...state.general,
        isAgeVerified: true,
        ageVerifiedTimestamp: timestamp,
      },
    }));
  },
  resetAgeVerification: () => {
    set(state => ({
      general: {
        ...state.general,
        isAgeVerified: false,
        ageVerifiedTimestamp: null,
      },
    }));
  },
  checkAgeVerification: () => {
    const storedState = localStorage.getItem('app-storage');

    if (!storedState) {
      return;
    }

    const parsedState = JSON.parse(storedState);
    const timestamp = parsedState?.state?.general?.ageVerifiedTimestamp;
    const isExpired = Date.now() - timestamp > AGE_VERIFICATION_EXPIRY_TIME;

    if (isExpired) {
      set(state => ({
        general: {
          ...state.general,
          isAgeVerified: false,
          ageVerifiedTimestamp: null,
        },
      }));
    }
  },
});
